import {
  Box,
  Center,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import { useState } from "react";

import CurrentImagePreview2 from "./currentImagePreview2";
import { selectProgressImage } from "@/reducer/designslice";
import { useAppSelector } from "@/store/hooks";

const CurrentImagePreview = () => {
  const progressImage = useAppSelector(selectProgressImage);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  return (
    <Flex
      sx={{
        width: "full",
        height: "full",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {progressImage ? (
        <Box color="#496AE1" fontSize="18px">
          <Center>
            <Image
              src={require("@/assets/images/" + progressImage.dataURL)}
              width={progressImage.width}
              height={progressImage.height}
              draggable={false}
              cursor="zoom-in"
              mb="20px"
              onClick={() => setIsPreviewOpen(true)}
              sx={{
                objectFit: "contain",
                maxWidth: "full",
                maxHeight: "full",
                height: "auto",
                borderRadius: "base",
                imageRendering: "pixelated",
              }}
            />
          </Center>
          <Center>生图中，请耐心等待...</Center>

          <Modal
            isOpen={isPreviewOpen}
            onClose={() => setIsPreviewOpen(false)}
            isCentered
            size="4xl"
          >
            <ModalOverlay bg="rgba(0, 0, 0, 0.72)" backdropFilter="blur(6px)" />
            <ModalContent
              bg="#0C0B10"
              border="1px solid #27314D"
              borderRadius="20px"
              boxShadow="0 24px 64px rgba(0, 0, 0, 0.42)"
            >
              <ModalCloseButton
                color="rgba(255, 255, 255, 0.72)"
                _hover={{ color: "#FFFFFF", bg: "rgba(255, 255, 255, 0.08)" }}
              />
              <ModalBody p="16px">
                <Image
                  src={require("@/assets/images/" + progressImage.dataURL)}
                  alt="progress-preview"
                  w="100%"
                  maxH="78vh"
                  objectFit="contain"
                  borderRadius="14px"
                  bg="rgba(255, 255, 255, 0.03)"
                />
              </ModalBody>
            </ModalContent>
          </Modal>
        </Box>
      ) : (
        <CurrentImagePreview2 />
      )}
    </Flex>
  );
};

export default CurrentImagePreview;
